export default __webpack_public_path__ + "static/media/22.28c61d12.svg";